<div class="header-wrapper">
<div class="topbar d-flex align-items-center">
  <!-- Search first — first visible flex item on desktop -->
  @if (searchEnabled) {
  <div class="search position-relative" [class.has-value]="searchQuery()">
    <i class="bi bi-search ico" aria-hidden="true" (click)="onSearch()"></i>
    <input type="text"
           class="w-100"
           placeholder="Search applications"
           aria-label="Search applications"
           [value]="searchQuery()"
           (input)="searchQuery.set($any($event.target).value)"
           (keydown.enter)="onSearch()" />
    @if (searchQuery()) {
      <button class="clear-btn" type="button" aria-label="Clear search" (click)="clearSearch()">
        <i class="bi bi-x" aria-hidden="true"></i>
      </button>
    }
  </div>
  }
  <!-- Mobile only: display:none on desktop; first flex items on mobile because .search is hidden -->
  <sas-button type="ghost" icon="bi-list" [iconOnly]="true" text="Open menu"
              class="mobile-burger"
              (sasOnClick)="menuService.toggleMobile()">
  </sas-button>
  <span class="mobile-brand">IEG</span>
  <div class="d-flex align-items-center ms-auto right-items">
      <!-- Mobile search trigger — sas-button matches the notification button style -->
    @if (searchEnabled) {
    <span class="mobile-search-wrapper">
      <sas-button type="icon"
                  icon="bi-search"
                  [iconOnly]="true"
                  text="Search"
                  [customClass]="searchOpen() ? 'active' : ''"
                  (sasOnClick)="toggleSearch()">
      </sas-button>
    </span>
    }
    <sas-language-selector [sasLangData]="languages"></sas-language-selector>
    <!-- App-specific header widgets (e.g. notifications), projected by the app -->
    <ng-content select="[headerActions]" />
    <sas-sign-user [mobileBreakpoint]="1023" />
  </div>
</div>

<!-- Mobile search panel: slides down when searchOpen() is true -->
@if (searchEnabled) {
<div class="mobile-search-panel" [class.open]="searchOpen()" [attr.aria-hidden]="!searchOpen()">
  <div class="search-inner position-relative" [class.has-value]="searchQuery()">
    <i class="bi bi-search ico" aria-hidden="true"></i>
    <input #mobileSearchInput
           type="text"
           class="w-100"
           placeholder="Search applications"
           aria-label="Search applications"
           [value]="searchQuery()"
           (input)="searchQuery.set($any($event.target).value)"
           (keydown.enter)="onSearch()"
           [attr.tabindex]="searchOpen() ? 0 : -1" />
    @if (searchQuery()) {
      <button class="clear-btn" type="button" aria-label="Clear search" [attr.tabindex]="searchOpen() ? 0 : -1" (click)="clearSearch()">
        <i class="bi bi-x" aria-hidden="true"></i>
      </button>
    }
  </div>
</div>
}
</div>
